import { blue200, blue600 } from 'material-ui/styles/colors';

const styles = {
    questionContainer: {
        borderLeft: blue600 + ' 3px solid',
        margin: '10px 15px 20px 15px',
        padding: '0 15px 15px 15px',
    },
    responseContainer: {
        display: 'flex',
        borderLeft: blue200 + ' 3px solid',
        margin: '10px 15px',
        padding: '0 15px 15px 15px',
        alignItems: "center",
        justifyContent: "flex-start",
        flexWrap: "wrap",
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/quiz/QuizForm/QuizForm.css.js